import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';

import {FuseHomeComponent} from './home.component';
import {NgxPermissionsGuard, NgxPermissionsModule} from 'ngx-permissions';
import {AgmCoreModule} from '@agm/core';
import {AgmSnazzyInfoWindowModule} from '@agm/snazzy-info-window';
import {NgxCarouselModule} from 'ngx-carousel';
import {ChatService} from '../chat/chat.service';
import {FuseWidgetModule} from '../../../../core/components/widget/widget.module';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {ShiftService} from '../../../services/shifts/shift.service';

const routes = [
    {
        path: 'pages/home',
        component: FuseHomeComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];


@NgModule({
    declarations: [
        FuseHomeComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule,
        NgxPermissionsModule
    ],
    exports: [
        FuseHomeComponent
    ],
    providers: [
        ChatService,
        ShiftService
    ],
    entryComponents: [
            ]
})

export class FuseHomeModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/home/home.module.ts